import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react/jsx-runtime';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

// eslint-disable-next-line react-refresh/only-export-components
export const RestrictedActionsMap = {
  download: <MyTrans i18nKey="action.download" />,
  forward: <MyTrans i18nKey="action.forward" />,
  copy: <MyTrans i18nKey="action.copy" />,
  screenshot: <MyTrans i18nKey="action.screenshot" />,
  screen_record: <MyTrans i18nKey="action.screenRecord" />,
};

export interface MsgGroupRestrictedActionsOffContentProps {
  message: Msg;
}

export const MsgGroupRestrictedActionsOffContent = memo(
  function MsgGroupRestrictedActionsOffContent({
    message,
  }: MsgGroupRestrictedActionsOffContentProps) {
    const { operator_user_id, disabled_actions } = message.payload;

    const { user: operatorUser } = useUserInfo(operator_user_id);

    return (
      <MyTrans
        i18nKey="chat.groupMessageRestrictedActionsOffText"
        components={{
          actionUser: (
            <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />
          ),
          action: <Text as="span" color="fg.muted" />,
          actions: (
            <Text as="span" color="fg.muted">
              {disabled_actions?.map((action: string, index: number) => (
                <Fragment key={index}>
                  {index > 0 && ', '}
                  {RestrictedActionsMap[action as keyof typeof RestrictedActionsMap]}
                </Fragment>
              ))}
            </Text>
          ),
          other: <Text as="span" color="fg.muted" />,
        }}
      ></MyTrans>
    );
  }
);
